module.exports = __webpack_public_path__ + "assets/img/main_cricket_bg_mob.png?15fb77689a1ce2dfa491c2dbab5a3025";